import queryKeys from '@/constants/queryKeys';
import { updateContent } from '@/services/api/requests/content';
import { TUpdateContentPayload } from '@/types/Content.types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const useUpdateContent = (id: string) => {
  const queryClient = useQueryClient();

  const { isPending, mutateAsync } = useMutation({
    mutationFn: async (payload: TUpdateContentPayload) => updateContent(id, payload),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [queryKeys.content.byId, id] });
      await queryClient.invalidateQueries({ queryKey: [queryKeys.content.all] });
    },
  });

  return { isPending, mutateAsync };
};

export default useUpdateContent;
